import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Recorder = React.lazy(() => import("@mediaspace/features/recorder"));
export const render = getDsLayoutComponentRenderer(Recorder);
